// extracted by mini-css-extract-plugin
module.exports = {"NotFoundPage":"NotFoundPage_NotFoundPage__1fhjq","dashboardBtn":"NotFoundPage_dashboardBtn__3_IBS"};